import { render, staticRenderFns } from "./hyjm.vue?vue&type=template&id=70f86202&scoped=true&"
var script = {}
import style0 from "./hyjm.vue?vue&type=style&index=0&id=70f86202&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f86202",
  null
  
)

export default component.exports